import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentExtractionService {
  
  private readonly documentExtract = environment.ApiDocumentExtractor || 'https://api.satelitales.dev.bayport-digital.com/v1/gateway-documents/api/v1/gateway-documents/documents-extractor';


  constructor(private http: HttpClient) {}

  uploadDocument(file: File, token: string): Observable<any> {
    const   formData = new FormData();
    formData.append('token', `Bearer ${token}`);
    formData.append('csid', '1');
    formData.append('file', file);
    return this.http.post(this.documentExtract, formData);
  }
}
